import { Select } from 'antd';

import { CarrierDTO, ShipmentClassification } from '@invenco/shipping-interface';

import { Form } from '@/components-ant/form';
import { FormModal } from '@/components-ant/form-modal';

import { useCarrierSelectionModal } from './useCarrierSelectionModal';

type Props = {
  isOpen: boolean;
  loading: boolean;
  carriers: CarrierDTO[];
  existingCarrierClassifications: Array<{
    carrierId: string;
    classification: ShipmentClassification | null;
  }>;
  onSave: (carrier: CarrierDTO, classification: ShipmentClassification | null) => void;
  onClose: () => void;
};

export function CarrierSelectionModal({
  isOpen,
  loading,
  carriers,
  existingCarrierClassifications,
  onSave,
  onClose,
}: Props) {
  const {
    models: { form, classificationOptions, hasExistingUnclassified },
    operations: { filter, submit, onCarrierChange },
  } = useCarrierSelectionModal({ carriers, existingCarrierClassifications, onSave, onClose });
  return (
    <FormModal
      title="Select Carrier"
      saveTitle="Select"
      open={isOpen}
      onSave={() => form.submit()}
      onCancel={onClose}
    >
      <Form layout="vertical" name="carrierSelection" form={form} onFinish={(data) => submit(data)}>
        <Form.Item
          name="carrierId"
          label="Carrier"
          rules={[{ required: true, message: 'Please select a carrier' }]}
        >
          <Select
            showSearch
            filterOption={filter}
            onChange={onCarrierChange}
            options={
              loading
                ? []
                : carriers.map((carrier) => ({
                    label: carrier.name,
                    value: carrier.id,
                  }))
            }
          />
        </Form.Item>
        <Form.Item
          name="classification"
          label="Classification"
          rules={
            hasExistingUnclassified
              ? [{ required: true, message: 'This carrier already has an unclassified entry' }]
              : undefined
          }
        >
          <Select
            allowClear={!hasExistingUnclassified}
            placeholder="All (unclassified)"
            options={classificationOptions}
          />
        </Form.Item>
      </Form>
    </FormModal>
  );
}
